import { useNavigate } from 'react-router-dom';
import { Button } from '@/shared/components';
import { useAuth } from '@/features/auth/hooks/useAuth';

export function ForbiddenPage() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleBack = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#f0f4f8] px-4">
      <div className="max-w-md rounded-2xl border border-slate-200/60 bg-white p-8 shadow-sm">
        <h1 className="text-xl font-semibold text-slate-900">Access denied</h1>
        <p className="mt-3 text-slate-600">
          You are signed in but do not have permission to access this dashboard. Please contact an
          administrator.
        </p>
        <div className="mt-6 flex gap-3">
          <Button variant="primary" onClick={handleBack}>
            Back to sign in
          </Button>
        </div>
      </div>
    </div>
  );
}
